<template>
  <div class="basicBox">
    <div class="centerBox">互联网药品信息服务资格证书证书编号:晋网药信备字(2025)00150号</div>
    <div class="centerBox">
      Copyright © 2018-2021 山西复盛公健康药业有限公司  版权所有  <span @click="jumpUrl()"> 备案号：晋ICP备2021008814号-5</span> 
      </div>  
    </div>
</template>

<script>
/**
 * 页面最底部那一行
 */
export default {
  name: 'FooterBottom',
  data(){
    return{
    }
  },
  methods:{
    jumpUrl(){
      window.open("https://beian.miit.gov.cn/")
    }
  }
}
</script>

<style scoped lang="less">
.basicBox{
  background: #343434;
  // display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  line-height: 50px;
  background: #242424;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  .centerBox{
    width: 100%;
    text-align: center;
    &:hover{
      cursor: pointer;
      font-weight: bold;
    }
  }
  span{
    padding-left:20px;
    &:hover{
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>
